import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import PageTitle from 'components/PageTitle';
import CarItem from 'components/CarItem';
import SearchCount from 'components/SearchCount';

import { URLS } from 'config';


import './styles.scss';
import containerActions from './actions';

class SearchPage extends React.Component {
  state = {
    cars: []
  }

  componentWillMount() {
    this.props.getSearch((cars) => {
      setTimeout(() => {
        clearInterval(this.timer);
        this.props.history.push(URLS.APPROVED);
      }, 5000);
      this.timer = setInterval(() => {
        if (this.state.cars.length !== cars.length) {
          this.setState(prevState => ({
            cars: [...prevState.cars, cars[this.state.cars.length]]
          }));
        } else {
          clearInterval(this.timer);
        }
      }, 300);
    });
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  timer = null;


  formatNumber = () => {
    const number = this.props.cars.length;
    if (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return number;
  }

  render() {
    return (
      <div className="page-search -not-full">
        {/* <button className="search-button">
          <i className="material-icons">close</i>
        </button> */}
        <PageTitle>
          Searching
        </PageTitle>
        <p className="search-subtitle">
          We searching our database of{' '}
          {this.formatNumber()} cars to find cars to match your criteria
        </p>
        <SearchCount count={this.props.cars.length} />
        <TransitionGroup className="search-list">
          {
            this.state.cars.map(car => (
              <CSSTransition
                key={car.id}
                classNames="car"
                timeout={500}
              >
                <CarItem name={car.name} image={car.image} perMounth={car.perMounth} />
              </CSSTransition>
            ))
          }
        </TransitionGroup>
      </div>
    );
  }
}

SearchPage.defaultProps = {
  cars: []
};

SearchPage.propTypes = {
  // eslint-disable-next-line
  cars: PropTypes.array,
  // eslint-disable-next-line
  history: PropTypes.object,
  getSearch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  cars: state.search.cars
});

export default connect(mapStateToProps, containerActions)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/Search/index.js